import { Injectable } from '@angular/core';

import { servicosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import {newRoute, editRoute, configuracaoRoute} from "../../../shared/services/data.service";
import { manutencoesRoute } from "../../shared/data.service";

@Injectable()
export class ServicoNavigationService {
    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = manutencoesRoute + '/' + configuracaoRoute + '/' + servicosRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = manutencoesRoute + '/' + configuracaoRoute + '/' + servicosRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = manutencoesRoute + '/' + configuracaoRoute + '/' + servicosRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/shared/servico-navigation.service.ts
 **/